import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../authentication.service';
import { take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { selectUserState, UserState } from '../../user-state';
import { BaseComponent } from '../../../core/base-component';
import { AppState } from '../../../app-state';
import { StorageService } from '../../../core/util/storage.service';
import { UserSetRedirectUrl } from '../../user-actions';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'mtn-authenticating',
  templateUrl: './authenticating.component.html',
  styleUrls: ['./authenticating.component.scss']
})
export class AuthenticatingComponent extends BaseComponent implements OnInit {

  private redirectUrl: string;

  constructor(
    private authenticationService: AuthenticationService,
    private storageService: StorageService,
    private router: Router,
    private route: ActivatedRoute,
    private store: Store<AppState>
  ) {
    super();
  }

  ngOnInit(): void {
    console.log("🚀 ~ AuthenticatingComponent ~ ngOnInit:")
    console.log('Current URL:', this.router.url);

    this.loadRedirectUrlFromStorage();
    this.subscribeToAuthStateChanges();
    this.continueAuthentication();
  }

  private continueAuthentication(): void {
    this.route.queryParams
      .pipe(take(1))
      .subscribe(params => {
        const code = params['code'];
        if (code) {
          this.authenticationService.continueAuthentication(code)
            .pipe(take(1))
            .subscribe(() => {
        this.authenticationService.redirect(this.redirectUrl);
            }, error => {
              console.error('Authentication failed:', error);
              this.router.navigate(['/login']); // Redirect to login or error page
            });
        } else {
          console.error('No code found in query parameters.');
          this.router.navigate(['/login']);
        }
      });
  }

  private loadRedirectUrlFromStorage(): void {
    this.storageService.get(StorageService.AUTH_REDIRECT_URL)
      .subscribe((redirectUrl: string) => {
        if (redirectUrl?.indexOf('maintenance')) {
          this.store.dispatch(UserSetRedirectUrl({url: '/'}));
        } else {
          this.store.dispatch(UserSetRedirectUrl({url: redirectUrl}));
        }
      });
  }

  private subscribeToAuthStateChanges(): void {
    this.addSubscription(
      selectUserState(this.store)
        .subscribe((state: UserState) => {
          this.redirectUrl = state.redirectUrl;
        })
    );
  }

}